var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferAClient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.447,
    height: 26.451,
    rx: 2.846,
    transform: "matrix(1 0 -.17863 .98392 4.725 .975)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.303 2.45h15.755c.743 0 1.238.593 1.105 1.325l-.996 5.487a.604.604 0 00.616.738c.414 0 .81-.33.884-.738l.996-5.487c.281-1.547-.765-2.8-2.337-2.8H7.57c-1.572 0-3.073 1.253-3.354 2.8L.509 24.2c-.281 1.546.765 2.8 2.337 2.8H18.6c1.572 0 3.073-1.254 3.354-2.8l1.355-7.462a.604.604 0 00-.616-.738c-.414 0-.81.33-.884.738L20.455 24.2c-.133.731-.843 1.324-1.586 1.324H3.114c-.743 0-1.238-.593-1.105-1.324L5.717 3.775c.133-.732.843-1.325 1.586-1.325z",
    fill: "#9CACC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.534 5.195h5.719M6.894 8.712h10.008M4.468 22.076h5.004M16.62 22.076h2.145",
    stroke: "#9CACC0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5DCDFA",
    d: "M5.49 16.45h14.298l-.51 2.813H4.978z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13h15m0 0l-2.77-3M29 13l-2.77 3",
    stroke: "#5DCDFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgReferAClient;